import { render, staticRenderFns } from "./LegalPage.vue?vue&type=template&id=18a6bf77&scoped=true"
import script from "./LegalPage.vue?vue&type=script&lang=js"
export * from "./LegalPage.vue?vue&type=script&lang=js"
import style0 from "./LegalPage.vue?vue&type=style&index=0&id=18a6bf77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6bf77",
  null
  
)

export default component.exports